import { render, staticRenderFns } from "./private-commercial-contract-customer-block.vue?vue&type=template&id=610972fa&"
import script from "./private-commercial-contract-customer-block.vue?vue&type=script&lang=js&"
export * from "./private-commercial-contract-customer-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610972fa')) {
      api.createRecord('610972fa', component.options)
    } else {
      api.reload('610972fa', component.options)
    }
    module.hot.accept("./private-commercial-contract-customer-block.vue?vue&type=template&id=610972fa&", function () {
      api.rerender('610972fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/private-commercial-contract-customer-block.vue"
export default component.exports